import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import Separator from "@components/CustomTypography/Separator/Separator"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import {getPosts} from "@config/modules"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import Gallery from "@jsons/gallery.json"
import MediaPage from "@jsons/mediaPage.json"
// import FeatureSection from "@pages/Media/FeatureSection"
import GallerySection from "@pages/Media/GallerySection/GallerySection"
import LogosListSection from "@pages/Media/Logos/LogosListSection"
import React from "react"

type Props = {}

const media = (props: Props): JSX.Element => {
	const pageData = getTranslatedPageData(MediaPage, true, true)
	const AdvancedSideAsset = getValueOrThrow(pageData.AdvancedSideAsset)

	const GalleryData = getPosts("MediaGalleryModule", {data: Gallery})

	return (
		<>
			<HeadMeta
				meta={pageData.metaData}
				customPath={"/inspiration/media"}
			/>

			<FullWidthHeader
				data={getValueOrThrow(AdvancedSideAsset[0].mainContent)[0]}
				position={"left"}
				size={"L"}
			/>
			{/* <LastPostSection data={Posts[0]} />

			<BlogPostsListSection
				data={Posts}
				pageData={AdvancedSideAsset[1]}
			/> */}

			<Separator size={128} />
			<GallerySection
				data={AdvancedSideAsset[1]}
				gallery={GalleryData[0]}
			/>

			<LogosListSection pageData={AdvancedSideAsset[2]} />

			{/* <FeatureSection
				data={Posts[5]}
				pageData={AdvancedSideAsset[4]}
				withHeader
			/> */}
		</>
	)
}

export default media
